import { Empty, Image, Table, TableProps } from 'antd';
import { useEffect, useState } from 'react';

import LoadingComponent from 'components/loadingComponent/loadingComponent';
import NotificationService from 'core/services/notification';
import { onGetBanks, onGetWalletTransactions } from 'modules/users/services/users';
import { WalletTransaction } from 'modules/users/models/wallet-transactions';
import { BankAccount } from 'modules/users/models/bank-account';
import { useTranslation } from 'react-i18next';
import NoData from 'components/noData/noData';
import { isRTL } from 'core/services/language';

interface InputProps {
	id: number;
}

function BankAccountsComponent({ id }: InputProps) {
	const { t } = useTranslation();

	const [isLoading, setIsLoading] = useState(true);
	const [bankAccounts, setBankAccounts] = useState<BankAccount[]>([]);

	useEffect(() => {
		getBankAccounts();
	}, []);

	const columns: TableProps<BankAccount>['columns'] = [
		{
			title: t('COMMON.ID'),
			dataIndex: 'id',
			key: 'id',
			render: (id) => <span style={{ fontWeight: 500, color: '#3F4254' }}>{id}</span>,
		},
		{
			title: t('USERS.NAME'),
			dataIndex: 'name',
			key: 'name',
			render: (name) => <span style={{ fontWeight: 500, color: '#3F4254' }}>{name}</span>,
		},
		{
			title: 'IBAN',
			dataIndex: 'iban',
			key: 'iban',
			render: (iban) => <span style={{ fontWeight: 500, color: '#7E8299' }}>{iban}</span>,
		},
		{
			title: t('USERS.BANK'),
			dataIndex: 'bank',
			key: 'bank',
			render: (bank) => <span style={{ fontWeight: 500, color: '#7E8299' }}>{isRTL() ? bank.name.ar : bank.name.en}</span>,
		},
		{
			title: t('USERS.LOGO'),
			dataIndex: 'bank',
			key: 'bank',
			render: (bank) => <Image src={bank.logo_url} style={{ width: 50, height: 50 }} />,
		},
		{
			title: t('COMMON.STATUS'),
			dataIndex: 'bank',
			key: 'bank',
			render: (bank) => <span className={`status ${bank.active ? 'active' : 'inactive'}`}>{bank.active ? 'Active' : 'Inactive'}</span>,
		},
	];

	const getBankAccounts = async () => {
		try {
			setIsLoading(true);

			const response = await onGetBanks(id);
			setBankAccounts(response.data.data.user_banks);

			setIsLoading(false);
		} catch (error) {
			NotificationService.error(t('COMMON.OPS'), t('COMMON.ERROR_OCCURRED'));
		}
	};

	return (
		<>
			{isLoading ? (
				<LoadingComponent />
			) : (
				<Table rowKey="id" columns={columns} dataSource={bankAccounts} scroll={{ x: 400 }} locale={{ emptyText: <NoData /> }} />
			)}
		</>
	);
}

export default BankAccountsComponent;
